"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getVideoUrl = getVideoUrl;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function getVideoUrl(_x) {
  return _getVideoUrl.apply(this, arguments);
}

function _getVideoUrl() {
  _getVideoUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(mediaId) {
    var infoUrl, videoRequestResult, playList, sources, optimalLongSide, longSideDiff, optimalMp4File, width, i, l, description;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            infoUrl = 'http://cdn.jwplayer.com/v2/media/' + mediaId;
            _context.next = 3;
            return _axios["default"].get(infoUrl, {});

          case 3:
            videoRequestResult = _context.sent;

            if (!(videoRequestResult.status === 200 && videoRequestResult.data)) {
              _context.next = 26;
              break;
            }

            playList = videoRequestResult.data.playlist[0];
            sources = playList.sources;
            optimalLongSide = null;
            longSideDiff = null;
            optimalMp4File = null;
            width = Math.max(window.innerHeight, window.innerWidth) || 640;
            i = 0, l = sources.length;

          case 12:
            if (!(i < l)) {
              _context.next = 22;
              break;
            }

            description = sources[i];

            if (!(description.label === 'Passthrough')) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("continue", 19);

          case 16:
            if (description.hasOwnProperty('width')) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("continue", 19);

          case 18:
            if (!optimalLongSide || Math.abs(width - description.width) < longSideDiff) {
              optimalMp4File = description.file;
              optimalLongSide = description.width;
              longSideDiff = Math.abs(width - optimalLongSide);
            }

          case 19:
            i++;
            _context.next = 12;
            break;

          case 22:
            if (!optimalMp4File) {
              _context.next = 24;
              break;
            }

            return _context.abrupt("return", {
              src: optimalMp4File,
              poster: playList.image
            });

          case 24:
            _context.next = 27;
            break;

          case 26:
            return _context.abrupt("return", false);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getVideoUrl.apply(this, arguments);
}